import { createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";
import { get_all_users,update_user } from "../actions/userAction";

const initial_state = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  users: [],
  meta: {},
  error_message: "",
};

const user_slice = createSlice({
  name: "user",
  initialState: initial_state,
  reducers: {},
  // extraReducers: (builder) => {
  //   builder

  //     .addCase(get_all_users.fulfilled, (state, action) => {
  //       state.users = action.payload.data;
  //       state.meta = action.payload.meta;
  //     })

  //     .addMatcher(isPending(get_all_users), (state) => {
  //       state.isLoading = true;
  //       state.isSuccess = false;
  //       state.isError = false;
  //     })

  //     .addMatcher(isRejected(get_all_users), (state, action) => {
  //       state.isError = true;
  //       state.isLoading = false;
  //       state.isSuccess = false;
  //       state.error_message = action.payload;
  //     })

  //     .addMatcher(isFulfilled(get_all_users), (state) => {
  //       state.isLoading = false;
  //       state.isSuccess = true;
  //       state.isError = false;
  //     });
  // },

  extraReducers: (builder) => {
    builder
  
      /* ================= GET USERS ================= */
      .addCase(get_all_users.fulfilled, (state, action) => {
        state.users = action.payload.data;
        state.meta = action.payload.meta;
      })
  
      /* ================= UPDATE USER ================= */
      .addCase(update_user.fulfilled, (state) => {
        state.isSuccess = true;
      })
  
      /* ================= LOADING ================= */
      .addMatcher(
        isPending(get_all_users, update_user),
        (state) => {
          state.isLoading = true;
          state.isSuccess = false;
          state.isError = false;
        }
      )
  
      /* ================= ERROR ================= */
      .addMatcher(
        isRejected(get_all_users, update_user),
        (state, action) => {
          state.isError = true;
          state.isLoading = false;
          state.isSuccess = false;
          state.error_message =
            action.payload?.message || action.payload;
        }
      )
  
      /* ================= SUCCESS ================= */
      .addMatcher(
        isFulfilled(get_all_users, update_user),
        (state) => {
          state.isLoading = false;
          state.isSuccess = true;
          state.isError = false;
        }
      );
  }
  
});

export default user_slice.reducer;
